"use strict";

var PropTypes = require("prop-types");

var BaseSearchPaging = require("./BaseSearchPaging");

class SponsorshipSearchPaging extends React.Component {
	handlePageChange(pageNumber) {
		var $searchResultsComponent = $(ReactDOM.findDOMNode(this)).closest("[data-component=sponsorshipSearchResults]");
		window.SponsorshipSearchHelper.performSponsorshipSearch($searchResultsComponent.attr("id"), pageNumber);
	}

	render() {
		return (
			<BaseSearchPaging
				{...this.props}
				thisArg={this}
				className="sponsorship-search-paging"
				previousPageSelector={`[data-component="sponsorshipSearchResults.populated.paging.previousPage"]`}
				nextPageSelector={`[data-component="sponsorshipSearchResults.populated.paging.nextPage"]`}
				onPageChange={this.handlePageChange.bind(this)}
				dataReactComponentName="SponsorshipSearchPaging"
				dataReactComponentCategory="SponsorshipSearchPagingComponents"
			/>
		);
	}
}

SponsorshipSearchPaging.propTypes = {
	isDesignMode: PropTypes.bool,
	dataChildOf: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataRepeatedId: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,

	numberPagesToShow: PropTypes.number,
	includeFirstPageNumber: PropTypes.bool,
	includeLastPageNumber: PropTypes.bool,
	currentPageNumber: PropTypes.number,
	pageSize: PropTypes.number,
	totalCount: PropTypes.number
};

module.exports = SponsorshipSearchPaging;
